//#region Imports
import React, { useEffect, useLayoutEffect, useState, useImperativeHandle, forwardRef } from 'react';
import { useLocation } from 'react-router-dom';
//MUI
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import { Box, Button, Grid, MenuItem, Select, TextField, Typography, useMediaQuery } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import warning from '../../../images/warning.png';
//components
import Base64Image from '../../../components/Base64Image/Base64Image';
import Error from '../../../components/error/error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import InfoIcon from '@mui/icons-material/Info';
//scss
// import "./InstallmentsTable.scss"
import "../../../style/common.scss";
import "./InstallmentsWorkflowDialog.scss";
import {
    WORKFLOW_MOBILE_MEDIA,
    workflowDialogClassName,
    workflowDialogShellProps,
} from '../../../utils/workflowDialogShell';
//Yup
import * as Yup from "yup";
//formik
import { useFormik } from 'formik';
//urls
import { cfpBaseUrl } from '../../../network/urls';
// use scan detection
import useScanDetection from 'use-scan-detection';
import CheckPermissions from '../../../authorization/authorization';
//Services
import { useDispatch, useSelector } from 'react-redux';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import BasicTable from '../../../components/basicTable/basicTable';
import ServiceDashboardTables from '../../../components/ServiceDashboardTables/ServiceDashboardTables';
import ProcessingSummaryTableBilling from '../../../components/processingSummaryTable/processingSummaryTableBilling';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { calculateInstallments, dBillAPI, downloadBill, getDocumentBackGroundColor, numberFormatting, subdivisionName, calculateLpsForApi } from '../../../services/Functions';
import OpenBase64ImageInPopup from '../../../services/OpenBase64ImageInPopup';
import { tableStyle, tableStyleOverDue } from '../../../style/common';
import RightArrow from '../../../images/right-arrow.png'
import {
    fetchPaginatedBillInstallmentNormal,
    filterDateFrom as filterDateFromNormal,
    filterDateTo as filterDateToNormal,
    filterObjectionStatus as filterObjectionStatusNormal,
    filterProgressId as filterProgressIdNormal,
    firstPage as firstPageNormal,
    lastPage as lastPageNormal,
    nextPage as nextPageNormal,
    previousPage as previousPageNormal,
    resetDateFilter as resetDateFilterNormal,
    resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
    resetProgressIdFilter as resetProgressIdFilterNormal,
    resetState as resetStateInstallmentsNormal,
} from '../../../features/billingAndCollection/installmentsNormalSlice';


import {
    fetchPaginatedBillInstallmentOverdue,
    filterDateFrom as filterDateFromOverdue,
    filterDateTo as filterDateToOverdue,
    filterObjectionStatus as filterObjectionStatusOverdue,
    filterProgressId as filterProgressIdOverdue,
    firstPage as firstPageOverdue,
    lastPage as lastPageOverdue,
    nextPage as nextPageOverdue,
    previousPage as previousPageOverdue,
    resetDateFilter as resetDateFilterOverdue,
    resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
    resetProgressIdFilter as resetProgressIdFilterOverdue,
    resetState as resetStateInstallmentsOverdue,
} from '../../../features/billingAndCollection/installmentsOverdueSlice';
import DoneIcon from '@mui/icons-material/Done';
import { getInitialAdminOfficeCode, isBillingTableFetchEnabled } from '../../../utils/adminCompany';
import { DISCO_COMPANIES } from '../../../constants/discoCompanies';

const parseInstallmentNumber = (val) =>
    parseInt(String(val ?? 0).replace(/,/g, ""), 10) || 0;

const toProgressId = (val) => Number(val);

/** Approved (1) → approved fields; rejected (-1) or pending (0) → applied fields */
const getDisplayNoOfInstallments = (row) => {
    if (!row) return 1;
    if (toProgressId(row.applicationProgressId) === 1) {
        return Number(row.approvedNoOfMonthsForinstallment) || 0;
    }
    return Number(row.noOfMonthsForInstallment) || 1;
};

const getDisplayDownPayment = (row) => {
    if (!row) return 0;
    if (toProgressId(row.applicationProgressId) === 1) {
        return parseInstallmentNumber(row.approvedDownPayment);
    }
    return parseInstallmentNumber(row.downPayment);
};

// Step bar has 2 steps: Submitted (0) and Action Taken (1).
// When progress is 1 (approved) or -1 (rejected), both steps show as completed (dark blue).
const getInstallmentStepIndex = (row) =>
    toProgressId(row?.applicationProgressId) === 0 ? 0 : 2;

const getInstallmentStepObjection = () => 0;

const InstallmentsTable = forwardRef((props, ref) => {

    const initialValues = {
        iv_down_payment: null,
        iv_no_of_installments: 1,
    }

    const { token, userId, code: officeCode, hierarchy: officeHierarchy, permissions, currentDateTime, selectedAdminCompanyCode } = useSelector((state) => state.auth)
    const isWorkflowMobile = useMediaQuery(WORKFLOW_MOBILE_MEDIA);
    const [selectedOfficeCode, setSelectedOfficeCode] = useState(
        getInitialAdminOfficeCode(officeCode, selectedAdminCompanyCode),
    );
    const canFetchBillingData = isBillingTableFetchEnabled(officeCode);
    const apiOfficeCode = String(officeCode) === "10"
        ? selectedOfficeCode
        : (selectedOfficeCode || officeCode);

    useEffect(() => {
        if (String(officeCode) === "10" && selectedAdminCompanyCode) {
            setSelectedOfficeCode(String(selectedAdminCompanyCode));
        }
    }, [officeCode, selectedAdminCompanyCode]);

    // Helper function to compare current date with due date
    const compareDates = (currentDateTimeStr, dueDateStr) => {
        const currentDate = new Date(currentDateTimeStr);
        const dueDate = new Date(dueDateStr);
        currentDate.setHours(0, 0, 0, 0);
        dueDate.setHours(0, 0, 0, 0);

        if (currentDate < dueDate) {
            return 'less';
        } else if (currentDate > dueDate) {
            return 'greater';
        } else {
            return 'equal';
        }
    };
    let divCode = officeCode.slice(0, 4)
    const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
    const dispatch = useDispatch();
    const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: errorNormal, isLoading: isLoad } = useSelector((state) => state.installmentNormalPaginated);
    const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: errorOverdue, isLoading: isLoadd } = useSelector((state) => state.installmentOverduePaginated);
    const [isReleventToUser, setIsRelevantToUser] = useState(false)

    const handleNextPage = () => {
        dispatch(nextPageNormal());
    };

    const handleDateFromFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromNormal(value))
        }
    }

    const handleDateToFilter = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToNormal(value))
        }
    }

    const handleResetDateFilter = () => {
        dispatch(resetDateFilterNormal())
    }

    const handleProgressIdFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdNormal(value))
        }
    }

    const handleResetProgressIdFilter = () => {
        dispatch(resetProgressIdFilterNormal())
    }

    const handleObjectionStatusFilter = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusNormal(value))
        }
    }

    const handleResetObjectionStatusFilter = () => {
        dispatch(resetObjectionStatusFilterNormal())
    }

    const handlePreviousPage = () => {
        dispatch(previousPageNormal());
    };

    const handleFirstPage = () => {
        dispatch(firstPageNormal());
    };

    const handleLastPage = (page) => {
      dispatch(lastPageNormal(typeof page === 'number' ? page : totalPagesNormal));
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/installments-table") && token && canFetchBillingData) {
            dispatch(fetchPaginatedBillInstallmentNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, officeCode: apiOfficeCode }));
        }
    }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal, apiOfficeCode, canFetchBillingData]);

    // useEffect(() => {
    //     if ((props.showTable && currentPath == "/installments-table")) {
    //         setViewBackdrop(true)
    //         dispatch(fetchPaginatedBillInstallmentNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
    //     }
    // }, []);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (dataNormal) {
            setInstallmentsApplicationsNormal(dataNormal)
            setViewBackdrop(false)
        }
    }, [dataNormal, canFetchBillingData])

    const handleNextPageOverdue = () => {
        dispatch(nextPageOverdue());
    };

    const handleDateFromFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateFromOverdue(value))
        }
    }

    const handleDateToFilterOverdue = (value) => {
        if (value) {
            setViewBackdrop(true)
            dispatch(filterDateToOverdue(value))
        }
    }

    const handleResetDateFilterOverdue = () => {
        dispatch(resetDateFilterOverdue())
    }

    const handleProgressIdFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterProgressIdOverdue(value))
        }
    }

    const handleResetProgressIdFilterOverdue = () => {
        dispatch(resetProgressIdFilterOverdue())
    }

    const handleObjectionStatusFilterOverdue = (value) => {
        if (value || value === 0) {
            setViewBackdrop(true)
            dispatch(filterObjectionStatusOverdue(value))
        }
    }

    const handleResetObjectionStatusFilterOverdue = () => {
        dispatch(resetObjectionStatusFilterOverdue())
    }

    const handlePreviousPageOverdue = () => {
        dispatch(previousPageOverdue());
    };

    const handleFirstPageOverdue = () => {
        dispatch(firstPageOverdue());
    };

    const handleLastPageOverdue = (page) => {
      dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
    };

    useEffect(() => {
        if ((props.showTable && currentPath == "/installments-table") && token && canFetchBillingData) {
            dispatch(fetchPaginatedBillInstallmentOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode: apiOfficeCode }));
        }
    }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue, apiOfficeCode, canFetchBillingData]);

    // useEffect(() => {
    //     if ((props.showTable && currentPath == "/installments-table")) {
    //         setViewBackdrop(true)
    //         dispatch(fetchPaginatedBillInstallmentOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
    //     }
    // }, []);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (dataOverdue) {
            setInstallmentsApplicationsOverdue(dataOverdue)
            setViewBackdrop(false)
        }
    }, [dataOverdue, canFetchBillingData])

    //#endregion

    //#region states 
    const [installmentsApplicationsNormal, setInstallmentsApplicationsNormal] = useState([]);
    const [installmentsApplicationsNormalToDataGrid, setInstallmentsApplicationsNormalToDataGrid] = useState([]);
    const [installmentsApplicationsOverdue, setInstallmentsApplicationsOverdue] = useState([]);
    const [installmentsApplicationsOverdueToDataGrid, setInstallmentsApplicationsOverdueToDataGrid] = useState([]);
    const [installmentsArray, setInstallmentsArray] = useState([])
    const [open, setOpen] = React.useState(false);
    const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
    const [dialogRowData, setDialogRowData] = React.useState({});
    const [applicationId, setapllicationid] = React.useState('')
    const [installmentdDialog, setinstallmentdDialog] = React.useState(false);
    const [showInstallmentsForm, setShowInstallmentsForm] = useState(false);
    const [currentBill, setCurrentBill] = useState(false);
    const [billMonth, setBillMonth] = useState(false);
    const [fpa, setFpa] = useState('');
    const [isOutstanding, setIsOutstanding] = useState("");
    const [arrears, setArrears] = useState(false);
    const [tableMonthDate, setTableMonthDate] = useState('')
    const [dBillMonthDate, setDBillMonthDate] = useState('')
    const [approvedNoOfInstallments, setApprovedNoOfInstallments] = useState(null);
    const [installmentsTable, setInstallmentsTable] = useState([])
    const [applicantCNIC, setApplicantCNIC] = useState();
    const [viewBackdrop, setViewBackdrop] = useState(false);

    useEffect(() => {
        if (!canFetchBillingData) {
            setInstallmentsApplicationsNormal([]);
            setInstallmentsApplicationsNormalToDataGrid([]);
            setInstallmentsApplicationsOverdue([]);
            setInstallmentsApplicationsOverdueToDataGrid([]);
            setViewBackdrop(false);
            dispatch(resetStateInstallmentsNormal());
            dispatch(resetStateInstallmentsOverdue());
        }
    }, [canFetchBillingData, dispatch]);

    const [totalInstallmentsPercentage, setTotalInstallmentsPercentage] = useState();
    const [applicationSubmittedPopUp, setApplicationSubmittedPopUp] = useState(false);
    const [copyOfApplicantCNICVerifyPopUp, setcopyOfApplicantCNICVerifyPopUp] = useState(false)
    const [downPayment, setDownPayment] = useState(null);
    const [approvedNoOfMonthsForinstallment, setApprovedNoOfMonthsForinstallment] = useState(null);
    const hideCopyOfApplicantCNICVerifyAlert = (x) => {
        setcopyOfApplicantCNICVerifyPopUp(x);
    }
    const [maxBillAmount, setMaxBillAmount] = useState(0);
    const [minDownPayment, setMinDownPayment] = useState(0);
    const [error, setError] = useState()
    const [sumOfValues, setSumOfValues] = useState(0)
    const [eFileData, setEFileData] = useState([]);
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [isDetectionBill, setIsDetectionBill] = useState(false)
    const [isDetMonth, setIsDetMonth] = useState("")
    const [isDetAmount, setIsDetAmount] = useState("")
    const [apiPopup, setApiPopup] = useState({
        open: false,
        title: '',
        message: '',
        type: '',
        innerMessage: ''
    });
    const [resultPopup, setResultPopup] = useState(null);
    const tableColumnsProcessingSummary = [
        {
            header: 'Step',
            accessorKey: 'stepName',
        },
        {
            header: 'Processed By',
            accessorKey: 'processedBy',
        },
        {
            header: 'Date',
            accessorKey: 'date',
        },
        {
            header: 'Remarks',
            accessorKey: 'remarks',
        },]

    let NCStatusBarArray = [
        {
            title1: 'APPLICATION',
            title2: 'SUBMITTED',
        },
        {
            title1: 'ACTION',
            title2: 'TAKEN',
        },

    ]
    const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
        {
            stepName: 'Application Submission',
            processedBy: 'Akram',
            date: '24-Dec-2023',
            time: '02:23:19 AM',
            remarks: '-',
        },
    ])

    const [foundInInstallments, setFoundInInstallments] = useState();
    const { state } = useLocation();
    const { foundId } = state ? state : '';
    //#endregion

    //#region constants / variables 

    const InstallmentsTableColumns = [{
        header: 'Sr.',
        accessorKey: 'serial',
    },
    {
        header: 'Percentage',
        accessorKey: 'percentage',
    },
    {
        header: 'Month',
        accessorKey: 'month',
    }]

    //#endregion 

    //#region api function
    const handleOpen = () => {
        setOpenCancelModal(true);
    };

    const handleCloseRemarks = () => {
        setOpenCancelModal(false);
        remarksFormik.resetForm({
            values: { iv_remarks: "" },
        });
    };

    const billHistoryFunc = async (refNo) => {
        let apiResponse = {}
        try {
            apiResponse = await dBillAPI(token, refNo)
            if (apiResponse.status) {
                setArrears(parseInt(apiResponse.basicInfo.arrear))
                setCurrentBill(parseInt(apiResponse.basicInfo.currAmntDue))
                setBillMonth(apiResponse.basicInfo.billMonth.slice(0, 10))
                setDBillMonthDate(apiResponse.basicInfo.billMonth)
            } else {
            }
        }
        catch (e) {
        }
        return apiResponse
    }


    const callGetInstallmentApplicantCNICDocument = async (applicationId) => {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "installments/getCNICImginstlmntAplicnts", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    setApplicantCNIC(result.CNICImage[0].applicantCNICImage)
                }
                else {
                }
            })
            .catch(() => {});
    }

    const callEfileAPI = async (application) => {

        var formdata = new FormData();
        formdata.append("applicationId", application.applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "installments/getInstallmentHistory", requestOptions)
            .then(response => response.json())
            .then(result => {
                if (result.status === "200") {
                    let applicationCurrentState = result.applicationCurrentState[0]
                    let applicationHistory = result.applicationHistory
                    if (applicationHistory === "No History Found") {
                        applicationHistory = []
                    }

                    applicationHistory.push(applicationCurrentState)
                    let sortedApplicationHistory = applicationHistory.sort((a, b) => {
                        const dateA = new Date(a.lastModificationDate)
                        const dateB = new Date(b.lastModificationDate)
                        return dateB - dateA
                    });

                    setEFileData(sortedApplicationHistory)
                    let dataforTable = []

                    sortedApplicationHistory.forEach(item => {
                        if (item.applicationProgressId !== 0 && item.lastModifiedBy && item.lastModificationDate) {
                            let object = {}
                            object.stepName = stepName(item.applicationProgressId)
                            object.processedBy = item.lastModifiedBy ? item.lastModifiedBy : 'Last Modified By Name'
                            object.date = item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'Last Modification Time'
                            object.remarks = item.remarks ? item.remarks : '-'
                            dataforTable.push(object)
                        }
                    })

                    dataforTable.push({
                        date: convertDate(application.creationDate),
                        processedBy: application.applicantName,
                        stepName: "Application Submitted",
                        time: convertDatewithTime(application.creationDate).slice(11, 17),
                        remarks: 'Application Submitted.'
                    })

                    setTableDataProcessingSummary(dataforTable);
                }
                else {
                }
            })
            .catch(() => {});
    }

    //#endregion

    //#region functions
    const openDetailsPopUp = async (stepName) => {
        let id = dialogRowData.applicationId

        if (stepName === "Application Submitted" || stepName === "APPLICATION SUBMITTED") {
            setApplicationSubmittedPopUp(true)
        }
    }

    useScanDetection({
        onComplete: async (code) => {
            if (code) {
                code = code.replace(/Shift/g, '');
                const regex = /^[A-Z]{2}-\d{14,15}$/;
                if (regex.test(code)) {
                    await handleRowClick(code);
                } else {
                }
            }
        },
        minLength: 4, // EAN13
    });

    const handleClose = async () => {
        setIsRelevantToUser(false)
        setFpa('');
        setArrears(false);
        setIsDetectionBill(false)
        setIsDetMonth("");
        setIsDetAmount("");
        setIsOutstanding("");
        setMaxBillAmount(0);
        setDownPayment(null)
        setMinDownPayment(0)
        setInstallmentsArray([])
        setapllicationid('')
        setDialogRowData({});
        installmentAPIFormik.resetForm();
        setOpen(false);

        if (props.showTable) {
            dispatch(fetchPaginatedBillInstallmentNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, officeCode: apiOfficeCode }));
            dispatch(fetchPaginatedBillInstallmentOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, officeCode: apiOfficeCode }));
        }
    };

    const getClassName = (x) => {
        if (x === "Pending") {
            return 'pending-button';
        }
        else if (x === "In Process") {
            return 'inprocess-button';
        }
        else if (x === "Approved") {
            return 'approved-button';
        }
        else if (x === "Objection") {
            return 'objection-button';
        }
        else if (x === "Rejected") {
            return 'rejected-button';
        }
    }

    const filterInstallmentApplication = async (applicationId) => {
        let normalArray = installmentsApplicationsNormal
        let totalArray = normalArray.concat(installmentsApplicationsOverdue)
        let itemFound = totalArray.find(item => item.applicationId === applicationId)

        if (itemFound) {
            setIsRelevantToUser(true)
        }
        else if (itemFound === undefined) {
            itemFound = await SearchIndividualApplication(token, applicationId, '8')
            setIsRelevantToUser(itemFound.isReleventToUser)
        }
        return itemFound;
    }

    const convertDate = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        return `${day}-${month}-${year}`;
    }

    const convertDatewithTime = (dateString) => {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const date = new Date(dateString);
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        const hour = date.getHours();
        const minute = date.getMinutes();
        const second = date.getSeconds();
        return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
    }

    const errorCloses = () => {
        setError('')
    }

    const apiToDataGridConversionNormal = () => {
        const tempArray = []
        if (installmentsApplicationsNormal) {
            installmentsApplicationsNormal.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "noOfInstallments": item.noOfMonthsForInstallment,
                            "billMonthAmount": numberFormatting(
                                (Number(item.currentMonthNetBill) || 0) +
                                // (Number(item.lps) || 0) +
                                (Number(item.outstanding) || 0) +
                                (Number(item.detectBillAmount) || 0)
                            ),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "noOfInstallments": item.noOfMonthsForInstallment,
                            "billMonthAmount": numberFormatting(
                                (Number(item.billMonthAmount) || 0) +
                                (Number(item.lps) || 0) +
                                (Number(item.arrears) || 0) +
                                (Number(item.billAdjustment) || 0) +
                                (Number(item.prevInstallment) || 0)
                            ),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "creationDate": ' ',
                "referenceNo": ' ',
                "applicantName": ' ',
                "noOfInstallments": ' ',
                "billMonthAmount": ' ',
                "applicationStatusId": ' ',
                "applicationProgressId": ' ',
            }
            tempArray.push(dataGridObject)
        }
        setInstallmentsApplicationsNormalToDataGrid(tempArray);
    }

    const apiToDataGridConversionOverdue = () => {
        const tempArray = []
        if (installmentsApplicationsOverdue) {
            installmentsApplicationsOverdue.forEach((item) => {
                let dataGridObject = {}
                if (item.applicationId) {
                    if (item.objectionStatus === 0) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "noOfInstallments": item.noOfMonthsForInstallment,
                            "billMonthAmount": numberFormatting(
                                (Number(item.currentMonthNetBill) || 0) +
                                (Number(item.lps) || 0) +
                                (Number(item.outstanding) || 0) +
                                (Number(item.detectBillAmount) || 0)
                            ),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": progFunc(item.applicationProgressId),
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    else if (item.objectionStatus === 1) {
                        dataGridObject = {
                            "applicationId": item.applicationId,
                            "creationDate": convertDate(item.creationDate),
                            "referenceNo": item.refNo,
                            "applicantName": item.applicantName,
                            "noOfInstallments": item.noOfMonthsForInstallment,
                            "billMonthAmount": numberFormatting(
                                (Number(item.billMonthAmount) || 0) +
                                (Number(item.lps) || 0) +
                                (Number(item.arrears) || 0) +
                                (Number(item.billAdjustment) || 0) +
                                (Number(item.prevInstallment) || 0)
                            ),
                            "applicationStatusId": statusFunc(item.applicationProgressId, item.objectionStatus),
                            "applicationProgressId": item.remarks,
                            "releventApplicationFlage": item.releventApplicationFlage,
                        }
                    }
                    tempArray.push(dataGridObject)
                }
            })
        }
        else {
            const dataGridObject = {
                "applicationId": ' ',
                "creationDate": ' ',
                "referenceNo": ' ',
                "applicantName": ' ',
                "noOfInstallments": ' ',
                "billMonthAmount": ' ',
                "applicationStatusId": ' ',
                "applicationProgressId": ' ',
            }
            tempArray.push(dataGridObject)
        }
        setInstallmentsApplicationsOverdueToDataGrid(tempArray);
    }

    const statusFunc = (x, objection) => {

        if (x === 0) {
            return 'In Process'
        }
        else if (x === 1) {
            return 'Approved'
        }
        else if (x === -1) {
            return 'Rejected'
        }
    }

    const progFunc = (x) => {
        if (x === 0) {
            return 'Documents Uploading'
        }
        else if (x === 1) {
            return 'Documents Verification'
        }
        else if (x === 2) {
            return 'Arrears Verification'
        }
        else if (x === 3) {
            return 'Field Verification'
        }
        else if (x === 4) {
            return 'Demand Note Issued'
        }
        else if (x === 5) {
            return 'DN Payment Verification'
        }
        else if (x === 6) {
            return 'Meter Installation'
        }
        else if (x === 7) {
            return 'Ready for Billing'
        }
    }

    const handleRowClick = async (applicationId, event) => {
        if (applicationId) {
            setViewBackdrop(true);
            const item = await filterInstallmentApplication(applicationId);
            await callGetInstallmentApplicantCNICDocument(item.applicationId);

            if (item && item.refNo) {
                const dBillResponse = await billHistoryFunc(item.refNo);

                if (dBillResponse.status) {
                    const basicInfo = dBillResponse.basicInfo;
                    const detInfo = dBillResponse.detInfo;

                    const netBill = parseInt(basicInfo.netBill?.replace(/,/g, '') || 0);
                    const lps = parseInt(basicInfo.LatePaymentSurcharge?.replace(/,/g, '') || 0);
                    const outstanding = parseInt(basicInfo.unpaid_debt?.replace(/,/g, '') || 0);
                    const fpa = parseInt(basicInfo.totalFpa?.replace(/,/g, '') || 0);
                    const billAdj = parseInt(basicInfo.billAdj?.replace(/,/g, '') || 0);
                    const prevInst = parseInt(basicInfo.installment?.replace(/,/g, '') || 0);
                    const arrearsAmt = parseInt(basicInfo.arrear?.replace(/,/g, '') || 0);

                    setFpa(fpa);

                    let detuctionAmt = 0;
                    if (basicInfo.isDetBill === true) {
                        setIsDetectionBill(true);
                        const detMonth = detInfo.DETBILMONTH || '';
                        setIsDetMonth(detMonth);
                        const detAmount = parseInt(detInfo.DETNETBILL?.replace(/,/g, '') || '0');
                        detuctionAmt = detAmount;
                        setIsDetAmount(detAmount);
                    }

                    const baseTotal = netBill + outstanding;
                    const grandTotal = baseTotal + detuctionAmt;

                    installmentAPIFormik.setFieldValue('iv_total_bill', baseTotal);
                    setMaxBillAmount(grandTotal);

                    const installmentCount = getDisplayNoOfInstallments(item);
                    const down = getDisplayDownPayment(item);

                    setApprovedNoOfInstallments(
                        item.applicationProgressId === 1
                            ? item.approvedNoOfMonthsForinstallment
                            : item.noOfMonthsForInstallment
                    );
                    setApprovedNoOfMonthsForinstallment(
                        item.applicationProgressId === 1
                            ? item.approvedNoOfMonthsForinstallment
                            : item.noOfMonthsForInstallment
                    );

                    installmentAPIFormik.setFieldValue(
                        'iv_no_of_installments',
                        installmentCount
                    );
                    installmentAPIFormik.setFieldValue('iv_down_payment', down);
                    setDownPayment(down);

                    const no = installmentCount || 1;
                    const remaining = Math.max(0, grandTotal - down);
                    let installmentParts = new Array(no).fill(Math.floor(remaining / no));
                    const remainder = remaining % no;
                    for (let j = 0; j < remainder; j++) {
                        installmentParts[j] += 1;
                    }

                    const installments = [down, ...installmentParts];
                    setInstallmentsArray(installments);

                    let dataforTable = [];

                    if (item.applicationProgressId === 0) {
                        dataforTable.push({
                            date: convertDate(item.creationDate),
                            processedBy: item.applicantName,
                            stepName: "Application Submitted",
                            time: convertDatewithTime(item.creationDate).slice(11, 17),
                            remarks: 'Application Submitted.'
                        });
                    }
                    else if (item.applicationProgressId === 1 || item.applicationProgressId === -1) {

                        dataforTable.push({
                            stepName: stepName(item.applicationProgressId),
                            processedBy: item.lastModifiedBy || 'N/A',
                            date: item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'N/A',
                            remarks: item.remarks || '-',
                        });

                        dataforTable.push({
                            date: convertDate(item.creationDate),
                            processedBy: item.applicantName,
                            stepName: "Application Submitted",
                            time: convertDatewithTime(item.creationDate).slice(11, 17),
                            remarks: 'Application Submitted.'
                        });

                    }

                    setTableDataProcessingSummary(dataforTable);

                    setapllicationid(item.applicationId);
                    setTableMonthDate(item.billMonth);
                    setDialogRowData(item);
                    setOpen(true);
                } else {
                    alert('Unable to get consumer billing history!');
                }
            }
            setViewBackdrop(false);
        }
    };


    const hideObjectionPopup = () => {
        setObjectionPopUpOpen(false);
    };

    const stepName = (x) => {
        if (x === 0) {
            return 'Application Submission'
        }
        else if (x === 1 || x === -1) {
            return 'Action Taken'
        }
    };

    const objectionpop = () => {
        setObjectionPopUpOpen(open)
    }

    useImperativeHandle(ref, () => ({
        handleRowClick
    }));

    //#endregion

    //#region formiks

    // Inside the InstallmentsTable component

    // Update useFormik configuration

    const installmentAPIFormik = useFormik({
        initialValues: {
            iv_down_payment: null,
            iv_no_of_installments: dialogRowData.noOfMonthsForInstallment || 1,
            iv_total_bill: null,
        },
        validationSchema: Yup.object().shape({
            iv_down_payment: Yup.number()
                .required('Enter Down Payment.')
                .min(0, 'Down Payment cannot be negative.')
                .max(Yup.ref('iv_total_bill'), ({ max }) =>
                    `Down Payment cannot exceed Grand Total (Rs. ${numberFormatting(parseInt(max, 10) || 0)}).`
                )
                .typeError('Down Payment must be a number.'),
            iv_no_of_installments: Yup.number()
                .required('Select number of installments.')
                .min(1, 'At least one installment is required.')
                .typeError('Number of installments must be a number.'),
            iv_total_bill: Yup.number()
                .required('Total Bill is missing.')
                .typeError('Total Bill must be a number.'),
        }),
        validate: (values) => {
            const errors = {};

            if (!installmentsArray || !Array.isArray(installmentsArray) || installmentsArray.length === 0) {
                errors.installments = 'Installment amounts are not initialized.';
            } else if (installmentsArray.some(amount =>
                amount === null ||
                amount === undefined ||
                isNaN(amount) ||
                amount === '' ||
                amount < 0
            )) {
                errors.installments = 'All installment amounts must be non-negative numbers.';
            }
            return errors;
        },
        onSubmit: async (values, { resetForm }) => {
            setViewBackdrop(true);
            try {
                const grandTotal = ((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) : 0)
                    +
                    (dialogRowData.detectBillAmount || isDetAmount ? parseInt(dialogRowData.detectBillAmount || isDetAmount) : 0)
                const numInstallments = parseInt(values.iv_no_of_installments);
                if (isNaN(grandTotal) || grandTotal <= 0) {
                    setError('Invalid total bill amount.');
                    setViewBackdrop(false);
                    return;
                }
                if (isNaN(numInstallments) || numInstallments < 1) {
                    setError('Invalid number of installments.');
                    setViewBackdrop(false);
                    return;
                }

                // Ensure no null or invalid values in installmentsArray (allow 0 now)
                const correctedInstallments = [...installmentsArray].map((amount, index) => {
                    if (amount === null || amount === undefined || isNaN(amount) || amount === '') {
                        // Fallback to equal split if invalid
                        const remaining = grandTotal - (values.iv_down_payment || 0);
                        const defaultAmount = Math.floor(remaining / numInstallments);
                        return defaultAmount;
                    }
                    return Math.max(0, amount);  // Ensure non-negative
                });

                // Re-validate after correction (allow 0)
                if (correctedInstallments.some(amount =>
                    amount === null || amount === undefined || isNaN(amount)
                )) {
                    setError('Failed to validate installment amounts. All amounts must be numbers.');
                    setViewBackdrop(false);
                    return;
                }

                const totalInstallmentsSum = correctedInstallments.reduce((sum, amount) => sum + amount, 0);
                if (totalInstallmentsSum !== grandTotal) {
                    setError(`Sum of installments (${numberFormatting(totalInstallmentsSum)}) does not match Grand Total (${numberFormatting(grandTotal)}).`);
                    setViewBackdrop(false);
                    return;
                }

                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    "remarks": "Approved.",
                    "applicationId": applicationId,
                    "applicationProgressId": 1,
                    "downPayment": correctedInstallments[0] || 0,
                    "approvedNoOfMonthsForinstallment": values.iv_no_of_installments
                });

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };

                const response = await fetch(cfpBaseUrl + "installments/processBillInstallment", requestOptions);
                const result = await response.json();

                // if (result.status === '200') {
                //     resetForm();
                //     handleClose();
                //     window.location.reload();
                // } else if (result.message?.startsWith('Since the month end process')) {
                //     setError(result.message);
                // } else {
                //     setError('Failed to submit the application.');
                // }
                if (result.status === '200') {
                    resetForm();
                    if (result.message) {
                        setApiPopup({
                            open: true,
                            title: 'Success',
                            message: result.message || 'Installment request approved successfully.',
                            type: 'success',
                            innerMessage: ''
                        });
                    }
                } else if (result.status === '400') {
                    setApiPopup({
                        open: true,
                        title: 'Error',
                        message: result.message || 'Failed to submit the application.',
                        type: 'error',
                        innerMessage: result.innerMessage || 'Failed to submit the application.'
                    });
                } else if (result.message?.startsWith('Since the month end process')) {
                    setApiPopup({
                        open: true,
                        title: 'Error',
                        message: result.message,
                        type: 'error',
                        innerMessage: ''
                    });
                } else {
                    setApiPopup({
                        open: true,
                        title: 'Error',
                        message: 'Something went wrong. Please try again.',
                        type: 'error',
                        innerMessage: ''
                    });
                }
            } catch (error) {
                setError('An error occurred while submitting. Please try again.');
            } finally {
                setViewBackdrop(false);
            }
        },
    });
    const handleClosePopup = () => {
        if (resultPopup) {
            setResultPopup(null);
            handleClose();
            return;
        }
        setApiPopup({ ...apiPopup, open: false });
        if (apiPopup.type === 'success') {
            handleClose();
        }
    };

    const instResultDialogConfig = {
        success: {
            Icon: CheckCircleIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--approve',
            title: 'Request Approved',
            showBill: true,
        },
        error: {
            Icon: HighlightOffIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--reject',
            title: 'Request Failed',
            showBill: false,
        },
        reject: {
            Icon: HighlightOffIcon,
            iconClassName: 'dde-result-dialog__icon dde-result-dialog__icon--reject',
            title: 'Request Rejected',
            message: 'Installment request is Rejected successfully.',
            showBill: false,
        },
    };

    const activeInstResultDialog = resultPopup
        ? instResultDialogConfig[resultPopup]
        : apiPopup.open && apiPopup.type
            ? instResultDialogConfig[apiPopup.type]
            : null;

    const activeResultMessage = resultPopup
        ? instResultDialogConfig[resultPopup]?.message
        : apiPopup.message;

    const activeResultInnerMessage = resultPopup ? '' : apiPopup.innerMessage;

    const handleInputChange = async (e, index) => {
        if (index !== 0) return;  // Only handle Down Payment (index 0); others disabled

        const { name, value } = e.target;

        if (value) {
            const parsedValue = parseInt(value);
            if (isNaN(parsedValue) || parsedValue < 0) {
                installmentAPIFormik.setFieldError('iv_down_payment', 'Down Payment must be a valid non-negative number.');
                return;
            }

            const grandTotal = ((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) : 0)
                +
                (dialogRowData.detectBillAmount || isDetAmount ? parseInt(dialogRowData.detectBillAmount || isDetAmount) : 0);
            if (parsedValue > grandTotal) {
                installmentAPIFormik.setFieldError('iv_down_payment', `Down Payment cannot exceed Grand Total (${numberFormatting(grandTotal)}).`);
                return;
            }

            installmentAPIFormik.setFieldValue('iv_down_payment', parsedValue);

            const remaining = Math.max(0, grandTotal - parsedValue);
            const no = parseInt(installmentAPIFormik.values.iv_no_of_installments || 1);
            let installmentParts = new Array(no).fill(Math.floor(remaining / no));
            const remainder = remaining % no;
            for (let j = 0; j < remainder; j++) {
                installmentParts[j] += 1;
            }

            // Update array: [new_down, ...parts]
            const updatedDataArray = [parsedValue, ...installmentParts];
            setInstallmentsArray(updatedDataArray);
        }
    };

    useEffect(() => {
        if (installmentAPIFormik.values.iv_no_of_installments && dialogRowData) {
            const no = parseInt(installmentAPIFormik.values.iv_no_of_installments);
            const down = parseInt(installmentAPIFormik.values.iv_down_payment) || 0;
            const grandTotal = ((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) : 0)
                +
                (dialogRowData.detectBillAmount || isDetAmount ? parseInt(dialogRowData.detectBillAmount || isDetAmount) : 0);

            // Recalc remaining and split
            const remaining = Math.max(0, grandTotal - down);
            let installmentParts = new Array(no).fill(Math.floor(remaining / no));
            const remainder = remaining % no;
            for (let j = 0; j < remainder; j++) {
                installmentParts[j] += 1;
            }

            // Update array: [down, ...parts]
            const installments = [down, ...installmentParts];
            setInstallmentsArray(installments);
        }
    }, [installmentAPIFormik.values.iv_no_of_installments, installmentAPIFormik.values.iv_down_payment, installmentAPIFormik.values.iv_total_bill, dialogRowData.lps]);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (installmentsApplicationsNormal) {
            apiToDataGridConversionNormal()
        }
    }, [installmentsApplicationsNormal, canFetchBillingData]);

    useEffect(() => {
        if (!canFetchBillingData) return;
        if (installmentsApplicationsOverdue) {
            apiToDataGridConversionOverdue()
        }
    }, [installmentsApplicationsOverdue, canFetchBillingData]);

    useEffect(() => {
        let TBill = currentBill + arrears
        let installmentsArray = [];
        let billDate = new Date();
        for (let i = 0; i < 2; i++) {
            let installmentObject = {}
            installmentObject.serial = i + 1
            billDate.setMonth(billDate.getMonth() + 1);
            let nextMonth = convertDate(`${billDate.getFullYear()}-${(billDate.getMonth()).toString().padStart(2, '0')}`).slice(2, 10);
            installmentObject.month = nextMonth;
            installmentObject.percentage = 50
            installmentsArray.push(installmentObject)
        }
        setInstallmentsTable(installmentsArray)
    }, [currentBill])

    useEffect(() => {
        let totalPercentage = 0;
        installmentsTable.forEach((item) => {
            totalPercentage = totalPercentage + item.percentage
        })
        setTotalInstallmentsPercentage(Math.round(totalPercentage))
    }, [installmentsTable])

    useEffect(() => {
        if (foundId && foundId !== '') {
            setFoundInInstallments(foundId)
        }
    }, [foundId])

    useLayoutEffect(() => {
        if (foundInInstallments) {
            handleRowClick(foundInInstallments)
        }
    }, [foundInInstallments])

    useEffect(() => {

    }, [])

    //#endregion

    const tblColumns = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "noOfInstallments", type: 'number', headerName: 'No. of Installments', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        { field: "billMonthAmount", headerName: 'Bill Amount', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyle.headerStyle,
            headerCellStyle: tableStyle.headerCellStyle,
            rowCellStyle: tableStyle.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return <div className={getClassName(btnText)}>{btnText}</div>
            }
        },
    ]

    const tblColumnsOverDue = [
        { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "creationDate", type: 'dateTime', headerName: 'Submission Date', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "referenceNo", headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "applicantName", headerName: 'Applicant Name', align: 'left', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "noOfInstallments", type: 'number', headerName: 'No. of Installments', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        { field: "billMonthAmount", headerName: 'Bill Amount', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
        {
            field: "applicationStatusId",
            headerStyle: tableStyleOverDue.headerStyle,
            headerCellStyle: tableStyleOverDue.headerCellStyle,
            rowCellStyle: tableStyleOverDue.rowCellStyle,
            headerName: "Status",
            align: 'center',
            sortable: false,
            filterable: true,
            type: 'singleSelect',
            valueOptions: ['In Process', 'Approved', 'Rejected'],
            renderCell: (params) => {
                let btnText = (params.applicationStatusId)
                return <div className={getClassName(btnText)}>{btnText}</div>
            }
        },
    ]

    useEffect(() => {
        // Keep API downPayment visible (including progressId = 0); only recalculate remaining installments.
        if (!installmentAPIFormik.values.iv_no_of_installments) return;
        if (!dialogRowData.billMonthAmount) return;

        const no = parseInt(installmentAPIFormik.values.iv_no_of_installments || 1);
        const down = parseInstallmentNumber(installmentAPIFormik.values.iv_down_payment);
        const grandTotal = ((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill)
            ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill)
            : 0) +
            (dialogRowData.detectBillAmount || isDetAmount
                ? parseInt(dialogRowData.detectBillAmount || isDetAmount)
                : 0);

        const remaining = Math.max(0, grandTotal - down);
        let installmentParts = new Array(no).fill(Math.floor(remaining / no));
        const remainder = remaining % no;
        for (let j = 0; j < remainder; j++) {
            installmentParts[j] += 1;
        }

        setInstallmentsArray([down, ...installmentParts]);
        setMinDownPayment(down);
    }, [
        installmentAPIFormik.values.iv_no_of_installments,
        installmentAPIFormik.values.iv_down_payment,
        installmentAPIFormik.values.iv_total_bill,
        dialogRowData.applicationProgressId,
        dialogRowData.currentMonthNetBill,
        dialogRowData.detectBillAmount,
        dialogRowData.billMonthAmount,
        isDetAmount
    ])

    const location = useLocation()
    const currentPath = location.pathname;

    // const installmentRanges = [
    //     { max: 50000, perm: '1 - 25,000', instPerm: '3 Installment' },
    //     { max: 50000, perm: '25001 - 50,000', instPerm: '3 Installment' },
    //     { max: 200000, perm: '50001 - 100,000', instPerm: '3 Installment' },
    //     { max: 500000, perm: '100,001 - 200,000', instPerm: '3 Installment' },
    //     { max: 1000000, perm: '200,001 - 500,000', instPerm: '4 Installment' },
    //     { max: 20000000, perm: '500,001 - 10,00,000', instPerm: '5 Installment' },
    //     { max: 20000000, perm: '10,00,001 - 20,000,000', instPerm: '12 Installment' },
    //     { max: Infinity, perm: '20,000,001 - MAX', instPerm: '40 Installment' },
    // ];

    useEffect(() => {
        if (dataNormal) {
            setInstallmentsApplicationsNormal(dataNormal);
            setViewBackdrop(false);
        }
    }, [dataNormal]);


    const installmentRanges = [
        { max: 25000, perm: '1 - 25,000', instPerm: '3 Installment' },
        { max: 50000, perm: '25,001 - 50,000', instPerm: '3 Installment' },
        { max: 100000, perm: '50,001 - 100,000', instPerm: '3 Installment' },
        { max: 200000, perm: '100,001 - 200,000', instPerm: '3 Installment' },
        { max: 500000, perm: '200,001 - 500,000', instPerm: '4 Installment' },
        { max: 1000000, perm: '500,001 - 1,000,000', instPerm: '5 Installment' },
        { max: 20000000, perm: '1,000,001 - 20,000,000', instPerm: '12 Installment' },
        { max: Infinity, perm: '20,000,001 - MAX', instPerm: '40 Installment' },
    ];


    const canApprove = (billAmount, permissions, ranges) => {
        for (let i = 0; i < ranges.length; i++) {
            const { max, perm } = ranges[i];
            const hasAmountPerm = CheckPermissions(
                permissions,
                "Billing and Collection",
                "Installments",
                "Workflow Permissions",
                perm
            );

            if (hasAmountPerm && billAmount <= max) {
                return true;
            }
        }
        return false;
    };
    const remarksFormik = useFormik({
        initialValues: {
            iv_remarks: "",
        },
        validationSchema: Yup.object({
            iv_remarks: Yup.string()
                .min(10, "Remarks should be at least 10 characters.")
                .max(100, "Remarks should be less than 100 characters.")
                .required("Enter remarks."),
        }),
        onSubmit: async (values) => {
            setViewBackdrop(true)
            try {
                const myHeaders = new Headers();
                myHeaders.append("Authorization", token);
                myHeaders.append("Content-Type", "application/json");

                const raw = JSON.stringify({
                    "applicationId": applicationId,
                    "applicationProgressId": -1,
                    "downPayment": 0,
                    "approvedNoOfMonthsForinstallment": 0,
                    "remarks": values.iv_remarks
                });

                const requestOptions = {
                    method: "POST",
                    headers: myHeaders,
                    body: raw,
                    redirect: "follow"
                };

                const response = await fetch(cfpBaseUrl + "installments/processBillInstallment", requestOptions);
                const result = await response.json();

                if (result.status === '200') {
                    remarksFormik.resetForm();
                    setOpenCancelModal(false);
                    setResultPopup('reject');
                } else if (result.message?.startsWith('Since the month end process')) {
                    setError(result.message);
                } else {
                    setError('Failed to submit the application.');
                }
            }
            catch (e) {
            }
            setViewBackdrop(false)
        },
    });
    const isSameMonthAndYear = (date1, date2) => {
        if (!date1 || !date2) return false;

        const d1 = date1.slice(0, 7);
        const d2 = date2.slice(0, 7);

        return d1 === d2;
    };

    return (
        <>
            {/* Applications Table */}
            <ServiceDashboardTables
                enabled={props.showTable && currentPath === "/installments-table"}
                comfortableRows
                isLoadingNormal={canFetchBillingData && isLoad}
                isLoadingOverdue={canFetchBillingData && isLoadd}
                normalTitle={`Bill Installments ( ${canFetchBillingData && numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )`}
                overdueCount={canFetchBillingData && numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"}
                normalColumns={tblColumns}
                overdueColumns={tblColumnsOverDue}
                normalData={canFetchBillingData ? installmentsApplicationsNormalToDataGrid : []}
                overdueData={canFetchBillingData ? installmentsApplicationsOverdueToDataGrid : []}
                onRowClick={handleRowClick}
                mobileFields={["applicationId", "applicantName", "applicationStatusId"]}
                showCompanyFilter={officeCode == 10}
                companies={DISCO_COMPANIES}
                selectedOfficeCode={selectedOfficeCode}
                onOfficeCodeChange={setSelectedOfficeCode}
                normalTableProps={{
                    firstPage: handleFirstPage,
                    lastPage: handleLastPage,
                    totalPages: totalPagesNormal,
                    totalRecords: totalRecordsNormal,
                    currentPage: currentPageNormal,
                    handleFilterDateFrom: handleDateFromFilter,
                    handleFilterDateTo: handleDateToFilter,
                    resetDateFilter: handleResetDateFilter,
                    handleFilterProgressId: handleProgressIdFilter,
                    handleFilterObjectionStatus: handleObjectionStatusFilter,
                    resetProgressIdFilter: handleResetProgressIdFilter,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilter,
                    nextPage: handleNextPage,
                    previousPage: handlePreviousPage,
                }}
                overdueTableProps={{
                    firstPage: handleFirstPageOverdue,
                    nextPage: handleNextPageOverdue,
                    previousPage: handlePreviousPageOverdue,
                    lastPage: handleLastPageOverdue,
                    handleFilterDateFrom: handleDateFromFilterOverdue,
                    handleFilterDateTo: handleDateToFilterOverdue,
                    resetDateFilter: handleResetDateFilterOverdue,
                    resetProgressIdFilter: handleResetProgressIdFilterOverdue,
                    resetObjectionStatusFilter: handleResetObjectionStatusFilterOverdue,
                    handleFilterProgressId: handleProgressIdFilterOverdue,
                    handleFilterObjectionStatus: handleObjectionStatusFilterOverdue,
                    totalPages: totalPagesOverdue,
                    totalRecords: totalRecordsOverdue,
                    currentPage: currentPageOverdue,
                }}
            />

            {/* Main Popup */}
            <Dialog
                open={open}
                onClose={handleClose}
                fullWidth={true}
                maxWidth="xl"
                {...workflowDialogShellProps(isWorkflowMobile)}
                className={workflowDialogClassName('main-dialog inst-workflow-dialog', isWorkflowMobile)}
                PaperProps={{ className: 'inst-workflow-dialog-paper' }}
            >
                <DialogTitle className="dialog-title" >
                    <div className="inst-dialog-header">
                        <Typography className="applicationTitleText">Installments -
                            <span style={{ color: 'white' }}>
                                {dialogRowData.applicationProgressId === 0 && ' Application Submitted'}
                                {dialogRowData.applicationProgressId === 1 && ' Action Taken'}
                                {dialogRowData.applicationProgressId === -1 && ' Request Declined'}
                            </span>
                        </Typography>
                        <button type="button" className="closeIcon" onClick={handleClose} aria-label="Close dialog">
                            <CloseIcon id="clearPopup" sx={{ color: 'white' }} />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent>
                    <DialogContentText className="dialog-content">
                        <Grid container className='headercontainer'>
                            <Grid item lg={12} className='status-bar'>
                                <StepProgressBar
                                    array={NCStatusBarArray}
                                    applicationProgressId={getInstallmentStepIndex(dialogRowData)}
                                    objection={getInstallmentStepObjection(dialogRowData)}
                                    submittedStepComplete={toProgressId(dialogRowData?.applicationProgressId) === 0}
                                    openDetailsPopUp={openDetailsPopUp}
                                    pageName='Installments'
                                />
                            </Grid>
                            <Grid item xs={12} className='application-details'>
                                <div className="inst-application-details-body">
                                <p className='inst-section-label'>Application Details</p>
                                <div className="inst-details-grid">
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Application Id.</p>
                                        <p className='prop-detail'>{dialogRowData.applicationId ? dialogRowData.applicationId : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Reference No.</p>
                                        <p className='prop-detail'>{dialogRowData.refNo ? dialogRowData.refNo : "-"}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Connection Type</p>
                                        <p className='prop-detail'>{dialogRowData.connectionType ? dialogRowData.connectionType : '-'}</p>
                                    </div>
                                    <div className='first-row-item inst-details-grid__tariff'>
                                        <p className='prop-title'>Tariff</p>
                                        <p className='prop-detail'>{dialogRowData.tariffCode ? dialogRowData.tariffCode : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Subdivision</p>
                                        <p className='prop-detail'>{dialogRowData.subDivisionCode ? subdivisionName(dialogRowData.subDivisionCode, subDivisions) : '-'}</p>
                                    </div>
                                    <div className='first-row-item inst-details-grid__bill-month'>
                                        <p className='prop-title'>Bill Month</p>
                                        <p className='prop-detail'>{dialogRowData.billMonth ? convertDate(dialogRowData.billMonth.slice(0, 7)).slice(2) : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Applicant Name</p>
                                        <p className='prop-detail'>{dialogRowData.applicantName ? dialogRowData.applicantName : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Applicant CNIC</p>
                                        <p className='prop-detail'>{dialogRowData.applicantCNIC ? dialogRowData.applicantCNIC : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Applicant Phone</p>
                                        <p className='prop-detail'>{dialogRowData.applicantPhone ? dialogRowData.applicantPhone : '-'}</p>
                                    </div>
                                    <div className='first-row-item'>
                                        <p className='prop-title'>Applicant Email</p>
                                        <p className='prop-detail'>{dialogRowData.applicantEmail ? dialogRowData.applicantEmail : "-"}</p>
                                    </div>
                                    <div className='first-row-item inst-details-grid__inst-count'>
                                        <p className='prop-title'>
                                            {dialogRowData.applicationProgressId === 1 ? 'Approved Insts.' : 'Applied Insts.'}
                                        </p>
                                        <p className='prop-detail'>{getDisplayNoOfInstallments(dialogRowData) || '-'}</p>
                                    </div>
                                    <div className='first-row-item inst-details-grid__bill-due'>
                                        <p className='prop-title'>Bill Due Date</p>
                                        <p className='prop-detail'>{dialogRowData.billMonthDueDate ? convertDate(dialogRowData.billMonthDueDate) : '-'}</p>
                                    </div>
                                    <div className='first-row-item inst-details-grid__address'>
                                        <p className='prop-title'>Address</p>
                                        <p className='prop-detail'>{dialogRowData.address ? dialogRowData.address : '-'}</p>
                                    </div>
                                </div>
                                </div>
                            </Grid>
                            <Grid item className='processing-summary'>
                                <p className='title'>Activity Log</p>

                                {/* Table Section */}
                                <Grid container>
                                    <Grid item xs={12}>
                                        <ProcessingSummaryTableBilling
                                            data={tableDataProcessingSummary}
                                            columns={tableColumnsProcessingSummary}
                                            openDetailsPopUp={openDetailsPopUp}
                                        />
                                    </Grid>
                                </Grid>

                                <div className="inst-cnic-section">
                                    <div
                                        className="inst-cnic-card"
                                        style={{ backgroundColor: getDocumentBackGroundColor() }}
                                    >
                                        <Typography className="inst-cnic-title">
                                            Applicant CNIC Image
                                        </Typography>

                                        {applicantCNIC ? (
                                            <div
                                                onClick={() => {
                                                    if (!copyOfApplicantCNICVerifyPopUp) {
                                                        setcopyOfApplicantCNICVerifyPopUp(true);
                                                    }
                                                }}
                                                style={{
                                                    cursor: "pointer",
                                                    display: "flex",
                                                    justifyContent: "center",
                                                }}
                                            >
                                                <Base64Image data={applicantCNIC} width={100} />
                                            </div>
                                        ) : (
                                            <Typography className="inst-cnic-empty">
                                                No image available
                                            </Typography>
                                        )}

                                        {copyOfApplicantCNICVerifyPopUp && (
                                            <OpenBase64ImageInPopup
                                                docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                                hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                                                documentName="Applicant CNIC"
                                                documentImage={applicantCNIC}
                                                width="100%"
                                                document={applicantCNIC}
                                                documentFlag={1}
                                                applicationProgressId={1}
                                                objectionStatus={0}
                                                titleToUpdateFlag="copyOfApplicantCNIC"
                                                flag_document={1}
                                                flag_documentBack={1}
                                            />
                                        )}
                                    </div>
                                </div>


                            </Grid>
                            <Grid item className="action-form">
                                <div className='fields'>
                                    {dialogRowData.applicationProgressId === 0 ?
                                        <>
                                            <h3 className='step-title'>
                                                <span className="inst-received-flow">
                                                    Application Received
                                                    {/mobile/i.test(String(dialogRowData.submittedThrough || ""))
                                                        ? ` from ${dialogRowData.submittedThrough}`
                                                        : ""}
                                                    {!/mobile/i.test(String(dialogRowData.submittedThrough || "")) && (
                                                        <span className="inst-flow-pill">
                                                            {dialogRowData.cfcName && dialogRowData.cfcName !== "PITC"
                                                                ? dialogRowData.cfcName
                                                                : dialogRowData.submittedThrough || " "}
                                                        </span>
                                                    )}
                                                    <img src={RightArrow} alt='forward to' className="inst-flow-arrow" />
                                                    <span className="inst-flow-pill">
                                                        {dialogRowData.referedToCFC ? dialogRowData.referedToCFC : '-'}
                                                    </span>
                                                </span>
                                            </h3>
                                        </> :
                                        dialogRowData.applicationProgressId === 1 ?
                                            <>
                                                <div className='step-title step-title--with-action'>
                                                    <h4>Installments Approved</h4>
                                                    <Button
                                                        variant="outlined"
                                                        className="inst-bill-btn"
                                                        onClick={() => { downloadBill(dialogRowData.refNo) }}
                                                    >
                                                        <DescriptionIcon sx={{ color: '#006ad1', fontSize: '1rem' }} /> Bill
                                                    </Button>
                                                </div>
                                            </>
                                            :
                                            dialogRowData.applicationProgressId === -1 ?
                                                <>
                                                    <h3 className='step-title'>Request Declined</h3>
                                                    <div className="description-box description-box--error">
                                                        <p className="group-description">
                                                            <InfoIcon className="icon" /> Application rejected
                                                        </p>
                                                    </div>
                                                </>
                                                :
                                                null
                                    }
                                    <Grid container>
                                        <Grid item lg={12} >
                                            <div className="inst-billing-history-action">
                                                <Button
                                                    type="button"
                                                    variant="outlined"
                                                    className="inst-billing-history-btn"
                                                    onClick={() => downloadBill(dialogRowData.refNo)}
                                                >
                                                    <DescriptionIcon sx={{ color: '#006ad1', fontSize: '1rem' }} />
                                                    Check Billing History — Click Here
                                                </Button>
                                            </div>
                                            {/* <Grid container className='sco-container' style={{
                                                display: 'grid', gridTemplateColumns: 'auto auto auto auto auto auto', padding: '5px', margin: '5px 17px'
                                            }} >
                                                <div className='item'>
                                                    <Typography className='label'> Month </Typography>
                                                    <Typography className='value'> {billMonth ? convertDate(billMonth).slice(2, 10) : '-'} </Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> Bill Amount</Typography>
                                                    <Typography className='value' > {dialogRowData.billMonthAmount ? numberFormatting(dialogRowData.billMonthAmount) : '-'}</Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> Arrears </Typography>
                                                    <Typography className='value'> {dialogRowData.arrears ? numberFormatting(dialogRowData.arrears) : '-'}</Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> Bill Adj. </Typography>
                                                    <Typography className='value'> {dialogRowData.billAdjustment ? numberFormatting(dialogRowData.billAdjustment) : '-'}</Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> Inst. </Typography>
                                                    <Typography className='value'> {dialogRowData.prevInstallment ? numberFormatting(dialogRowData.prevInstallment) : '-'}</Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> Total </Typography>
                                                    <Typography className='value'>
                                                        {numberFormatting(installmentAPIFormik.values.iv_total_bill)}
                                                    </Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> LPS </Typography>
                                                    <Typography className='value'> {dialogRowData.lps ? numberFormatting(dialogRowData.lps) : '-'}</Typography>
                                                </Grid>
                                                <div className='item'>
                                                    <Typography className='label'> Net Total </Typography>
                                                    <Typography className='value'>
                                                        {numberFormatting(parseInt(installmentAPIFormik.values.iv_total_bill || 0) + (dialogRowData.lps ? parseInt(dialogRowData.lps) : 0))}
                                                    </Typography>
                                                </Grid>
                                            </Grid> */}

                                            <div className='sco-container'>
                                                {
                                                    (dialogRowData.arrears != '' && dialogRowData.arrears != '0' && dialogRowData.arrears != undefined)
                                                        ?
                                                        <>
                                                            <div className='item'>

                                                                <Typography className='label'> Arrears </Typography>


                                                                <Typography className='value'> {dialogRowData.arrears ? numberFormatting(dialogRowData.arrears) : '-'}</Typography>


                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                                                }
                                                {
                                                    (dialogRowData.billMonthAmount != '' && dialogRowData.billMonthAmount != '0' && dialogRowData.billMonthAmount != undefined)
                                                        ?
                                                        <>
                                                            <div className='item'>

                                                                <Typography className='label'> Bill Amount</Typography>

                                                                <Typography className='value' > {dialogRowData.billMonthAmount ? numberFormatting(dialogRowData.billMonthAmount) : '-'}</Typography>


                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                                                }

                                                {
                                                    (dialogRowData.billAdjustment != '' && dialogRowData.billAdjustment != '0' && dialogRowData.billAdjustment != undefined)
                                                        ?
                                                        <>

                                                            <div className='item'>
                                                                <Typography className='label'> Bill Adj. </Typography>

                                                                <Typography className='value'> {dialogRowData.billAdjustment ? numberFormatting(dialogRowData.billAdjustment) : '-'}</Typography>

                                                            </div>
                                                        </>
                                                        :
                                                        <></>
                                                }
                                                {
                                                    (dialogRowData.prevInstallment != '' && dialogRowData.prevInstallment != '0' && dialogRowData.prevInstallment != undefined)
                                                        ?
                                                        <>
                                                            <div className='item'>

                                                                <Typography className='label'> Inst. </Typography>

                                                                <Typography className='value'> {dialogRowData.prevInstallment ? numberFormatting(dialogRowData.prevInstallment) : '-'}</Typography>


                                                            </div>
                                                        </>
                                                        :
                                                        <>  </>
                                                }

                                                {
                                                    ((dialogRowData.totalFPA != '' && dialogRowData.totalFPA != '0' && dialogRowData.totalFPA != undefined) || (fpa != '' && fpa != '0' && fpa != undefined))
                                                        ?
                                                        <>
                                                            <div className='item'>

                                                                <Typography className='label'>FPA. </Typography>

                                                                <Typography className='value'> {(dialogRowData.totalFPA || fpa) ? numberFormatting(dialogRowData.totalFPA || fpa) : '-'}</Typography>


                                                            </div>
                                                        </>
                                                        :
                                                        <>  </>
                                                }

                                                {
                                                    ((dialogRowData.outstandingAmount != '' && dialogRowData.outstandingAmount != '0' && dialogRowData.outstandingAmount != undefined) || (isOutstanding != '' && isOutstanding != '0' && isOutstanding != undefined))
                                                        ?
                                                        <>
                                                            <div className='item'>
                                                                <Typography className='label'>Outstanding Amount </Typography>

                                                                <Typography className='value'> {(dialogRowData.outstandingAmount || isOutstanding) ? numberFormatting(dialogRowData.outstandingAmount || isOutstanding) : '-'}</Typography>

                                                            </div>
                                                        </>
                                                        :
                                                        <>  </>
                                                }


                                                <div className='item'>
                                                    <Typography className='label'> Total </Typography>
                                                    {/* <Typography sx={{ background: 'rgb(0, 106, 209)', color: 'white', borderRadius: '5px', width: 'auto', padding: '5px', fontSize: '14px', margin: '0px 5px', border: '1px solid rgb(199, 199, 199)' }}>
                                                      
                                                        {numberFormatting(((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) : 0))}

                                                    </Typography> */}
                                                    <Typography className="inst-total-badge">
                                                        {
                                                            numberFormatting(
                                                                (
                                                                    parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill || 0)
                                                                    -
                                                                    (
                                                                        compareDates(currentDateTime, dialogRowData.billMonthDueDate) === 'greater'
                                                                            && dialogRowData.lps
                                                                            && dialogRowData.lps !== '0'
                                                                            ? parseInt(dialogRowData.lps)
                                                                            : 0
                                                                    )
                                                                )
                                                            )
                                                        }
                                                    </Typography>

                                                </div>
                                                {
                                                    (compareDates(currentDateTime, dialogRowData.billMonthDueDate) === 'greater' && dialogRowData.lps != '' && dialogRowData.lps != '0' && dialogRowData.lps != undefined)
                                                        ?
                                                        <>
                                                            <div className='item'>
                                                                <Typography className='label'> LPS </Typography>
                                                                <Typography className='value'> {dialogRowData.lps ? numberFormatting(dialogRowData.lps) : '-'}</Typography>
                                                            </div>
                                                        </>
                                                        :
                                                        <>  </>
                                                }

                                                {
                                                    (dialogRowData.detectBillAmount > 0 || isDetAmount > 0) &&
                                                    <>


                                                        <div className='item'>
                                                            <Typography className='label'>Det Bill Month</Typography>
                                                            <Typography className='value'>
                                                                {dialogRowData.detectBillMonth || isDetMonth}
                                                            </Typography>
                                                        </div>
                                                        <div className='item'>
                                                            <Typography className='label'>Det Amount </Typography>
                                                            <Typography className='value'>
                                                                {(dialogRowData.detectBillAmount || isDetAmount) ? numberFormatting(dialogRowData.detectBillAmount || isDetAmount) : '-'}
                                                            </Typography>
                                                        </div>
                                                    </>
                                                }


                                                <div className='item'>
                                                    <Typography className='label'> Net Total </Typography>
                                                    <Typography className="inst-total-badge">
                                                        {numberFormatting(((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) : 0)
                                                            +
                                                            (dialogRowData.detectBillAmount || isDetAmount ? parseInt(dialogRowData.detectBillAmount || isDetAmount) : 0))
                                                        }
                                                    </Typography>
                                                </div>
                                            </div>
                                        </Grid>
                                    </Grid>

                                    <div className="inst-installments-section">
                                        <div className="inst-installments-grid">
                                            <div className="inst-installments-select-wrap">
                                                <Typography className="fieldLabel inst-installments-label" component="div">
                                                    <span>No. of Installments</span>
                                                    <span className="inst-allowed-tag">ALLOWED</span>
                                                </Typography>
                                                <Select
                                                        disabled={toProgressId(dialogRowData.applicationProgressId) !== 0}
                                                        value={
                                                            toProgressId(dialogRowData.applicationProgressId) !== 0
                                                                ? getDisplayNoOfInstallments(dialogRowData)
                                                                : installmentAPIFormik.values.iv_no_of_installments
                                                        }
                                                        onChange={installmentAPIFormik.handleChange}
                                                        onBlur={installmentAPIFormik.handleBlur}
                                                        className='fieldBatch'
                                                        name="iv_no_of_installments"
                                                        id="iv_no_of_installments"
                                                        fullWidth
                                                        size="small"
                                                    >
                                                        {/* Placeholder */}
                                                        <MenuItem value="" disabled>
                                                            <em>No. of installments</em>
                                                        </MenuItem>

                                                        {(() => {
                                                            let maxInst = 0;

                                                            if (
                                                                CheckPermissions(
                                                                    permissions,
                                                                    "Billing and Collection",
                                                                    "Installments",
                                                                    "Workflow Permissions",
                                                                    "3 Installment"
                                                                )
                                                            ) {
                                                                maxInst = 2;
                                                            } else if (
                                                                CheckPermissions(
                                                                    permissions,
                                                                    "Billing and Collection",
                                                                    "Installments",
                                                                    "Workflow Permissions",
                                                                    "4 Installment"
                                                                )
                                                            ) {
                                                                maxInst = 3;
                                                            } else if (
                                                                CheckPermissions(
                                                                    permissions,
                                                                    "Billing and Collection",
                                                                    "Installments",
                                                                    "Workflow Permissions",
                                                                    "5 Installment"
                                                                )
                                                            ) {
                                                                maxInst = 4;
                                                            } else if (
                                                                CheckPermissions(
                                                                    permissions,
                                                                    "Billing and Collection",
                                                                    "Installments",
                                                                    "Workflow Permissions",
                                                                    "12 Installment"
                                                                )
                                                            ) {
                                                                maxInst = 11;
                                                            } else if (
                                                                CheckPermissions(
                                                                    permissions,
                                                                    "Billing and Collection",
                                                                    "Installments",
                                                                    "Workflow Permissions",
                                                                    "40 Installment"
                                                                )
                                                            ) {
                                                                maxInst = 39;
                                                            }

                                                            const currentInstallmentValue =
                                                                toProgressId(dialogRowData.applicationProgressId) !== 0
                                                                    ? (getDisplayNoOfInstallments(dialogRowData) || 1)
                                                                    : (parseInt(installmentAPIFormik.values.iv_no_of_installments) || 1);

                                                            const optionUpperBound = Math.max(
                                                                maxInst,
                                                                currentInstallmentValue,
                                                                1
                                                            );

                                                            return Array.from({ length: optionUpperBound }, (_, i) => (
                                                                <MenuItem key={i + 1} value={i + 1}>
                                                                    {i + 1}
                                                                </MenuItem>
                                                            ));
                                                        })()}

                                                    </Select>
                                            </div>
                                            {
                                                (() => {
                                                    const inputFields = [];
                                                    const grandTotal = ((dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) ? parseInt(dialogRowData.currentMonthNetBill || installmentAPIFormik.values.iv_total_bill) : 0)
                                                        +
                                                        (dialogRowData.detectBillAmount || isDetAmount ? parseInt(dialogRowData.detectBillAmount || isDetAmount) : 0)
                                                    const noOfInstallmentsForView =
                                                        toProgressId(dialogRowData.applicationProgressId) !== 0
                                                            ? getDisplayNoOfInstallments(dialogRowData)
                                                            : installmentAPIFormik.values.iv_no_of_installments;

                                                    for (let i = 0; i <= (noOfInstallmentsForView || 1); i++) {
                                                        inputFields.push(
                                                            <div className="inst-installment-field" key={i}>
                                                                <Typography className='fieldLabel'>
                                                                    {i === 0 ? 'Down Payment' : `Inst. ${i}`}
                                                                </Typography>
                                                                <TextField
                                                                    disabled={i !== 0 ||
                                                                        toProgressId(dialogRowData.applicationProgressId) === 1 ||
                                                                        toProgressId(dialogRowData.applicationProgressId) === -1
                                                                    }
                                                                    name={i === 0 ? 'iv_down_payment' : `installment_${i}`}
                                                                    value={installmentsArray[i] || ''}
                                                                    type="number"
                                                                    id={i === 0 ? 'iv_down_payment' : ''}
                                                                    className='fieldCoverageMarla'
                                                                    fullWidth
                                                                    size="small"
                                                                    inputProps={{
                                                                        max: i === 0 ? grandTotal : undefined,
                                                                        min: 0
                                                                    }}
                                                                    onChange={(e) => handleInputChange(e, i)}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                    return inputFields;
                                                })()
                                            }
                                        </div>
                                        {installmentAPIFormik.errors.iv_down_payment ? (
                                            <p className="inst-down-payment-error">
                                                {installmentAPIFormik.errors.iv_down_payment}
                                            </p>
                                        ) : null}
                                        <p className="inst-billing-warning">
                                            ** This does not includes applicable financial charges **
                                        </p>
                                        {error ? (
                                            <Error
                                                error={error}
                                                onClose={() => errorCloses()}
                                                backgroundColor="#FFC0CB"
                                                textColor="#bb0303"
                                                iconColor="#bb0303"
                                            />
                                        ) : null}
                                    {!isReleventToUser && (
                                        <div className="description-box description-box--error">
                                            <p className="group-description">
                                                <InfoIcon className="icon" />
                                                Application doesn&apos;t belong to your office.
                                            </p>
                                        </div>
                                    )}
                                    </div>
                                </div>

                                <div className="actions">
                                    {/* {dialogRowData.applicationProgressId === 0 &&
                                        isReleventToUser ?
                                        canApprove(maxBillAmount, permissions, installmentRanges) && (
                                            <>
                                                {isSameMonthAndYear(dBillMonthDate, tableMonthDate) && (
                                                    <button
                                                        className="view-button"
                                                        onClick={installmentAPIFormik.handleSubmit}
                                                    >
                                                        Approve
                                                    </button>
                                                )}
                                                <button
                                                    className="reject-button"
                                                    style={{ float: "right", marginRight: "10px" }}
                                                    onClick={handleOpen}
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        )
                                        :
                                        <div style={{ margin: 'auto', padding: '10px', backgroundColor: '#C46500', color: 'white', borderRadius: '5px', textAlign: 'center' }}>
                                            <p style={{ fontSize: '20px' }}>
                                                Application doesn't belongs to your office.
                                            </p>
                                        </div>
                                    } */}


                                    {!isSameMonthAndYear(dBillMonthDate, tableMonthDate) &&
                                        toProgressId(dialogRowData.applicationProgressId) !== 1 &&
                                        toProgressId(dialogRowData.applicationProgressId) !== -1 && (
                                        <div className="description-box description-box--error">
                                            <p className="group-description">
                                                <InfoIcon className="icon" />
                                                Your installment can&apos;t be processed for this billing month — please apply again with the correct month.
                                            </p>
                                        </div>
                                    )}
                                    {isReleventToUser == true ? (
                                        dialogRowData.applicationProgressId === 0 &&
                                        canApprove(maxBillAmount, permissions, installmentRanges) && (
                                            <>
                                                {isSameMonthAndYear(dBillMonthDate, tableMonthDate) && (
                                                    <button
                                                        type="button"
                                                        className="view-button"
                                                        onClick={installmentAPIFormik.handleSubmit}
                                                    >
                                                        Approve
                                                    </button>
                                                )}
                                                <button
                                                    type="button"
                                                    className="reject-button"
                                                    onClick={handleOpen}
                                                >
                                                    Cancel
                                                </button>
                                            </>
                                        )
                                    ) : null}


                                </div>


                            </Grid>
                        </Grid>
                    </DialogContentText >
                </DialogContent >
            </Dialog >

            {/* < Dialog
                open={ApplicationsubmittedPopUp}
                onClose={() => { setApplicationSubmittedPopUp(false) }}
                fullWidth={true}
                maxWidth={'md'}
                className='subpopup-dialog' >
                <DialogTitle className='dialog-title'>
                    <p className='title'>
                        Application Submitted
                    </p>
                    <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setApplicationSubmittedPopUp(false) }} />
                </DialogTitle>
            </Dialog > */}

            <Dialog
                open={applicationSubmittedPopUp}
                onClose={() => setApplicationSubmittedPopUp(false)}
                fullWidth
                maxWidth="md"
                className="wf-submitted-dialog"
                PaperProps={{ className: 'wf-submitted-dialog__paper' }}
            >
                <DialogTitle className="dialog-title">
                    <div className="wf-dialog-header">
                        <Typography className="wf-dialog-title-text">Application Submitted</Typography>
                        <button
                            type="button"
                            className="wf-dialog-close"
                            onClick={() => setApplicationSubmittedPopUp(false)}
                            aria-label="Close dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="wf-submitted-dialog__content">
                    <div className="wf-application-details-body">
                        <p className="wf-section-label">Application Details</p>
                        <div className="wf-details-grid">
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Application Id</p>
                                <p className="prop-detail">{dialogRowData.applicationId || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Applicant Name</p>
                                <p className="prop-detail">{dialogRowData.applicantName || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Received From</p>
                                <p className="prop-detail">{dialogRowData.cfcName || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Applied Date</p>
                                <p className="prop-detail">{convertDate(dialogRowData.creationDate) || '-'}</p>
                            </div>
                            <div className="wf-detail-item wf-detail-item--span2">
                                <p className="prop-title">Subdivision</p>
                                <p className="prop-detail">
                                    {subdivisionName(dialogRowData.subDivisionCode, subDivisions) || '-'}
                                </p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Connection Type</p>
                                <p className="prop-detail">{dialogRowData.connectionType || '-'}</p>
                            </div>
                            <div className="wf-detail-item">
                                <p className="prop-title">Sub. Through</p>
                                <p className="prop-detail">{dialogRowData.submittedThrough || '-'}</p>
                            </div>
                        </div>
                    </div>
                </DialogContent>
                <DialogActions className="wf-submitted-dialog__footer">
                    <p className="wf-submitted-dialog__footer-text">
                        Application Submitted by:{' '}
                        {String(dialogRowData.createdBy).length === 13 && /^\d+$/.test(dialogRowData.createdBy)
                            ? dialogRowData.applicantName
                            : dialogRowData.createdBy}{' '}
                        on: {convertDatewithTime(dialogRowData.creationDate)}
                    </p>
                </DialogActions>
            </Dialog>


            {/* Remarks Dialog */}
            <Dialog
                open={openCancelModal}
                className="inst-remarks-dialog"
                onClose={handleCloseRemarks}
                maxWidth="sm"
                fullWidth
                PaperProps={{ className: 'inst-remarks-dialog__paper' }}
            >
                <DialogTitle className="inst-remarks-dialog__title">
                    <div className="inst-remarks-dialog__header">
                        <Typography className="inst-remarks-dialog__heading">Remarks</Typography>
                        <button
                            type="button"
                            className="inst-remarks-dialog__close"
                            onClick={handleCloseRemarks}
                            aria-label="Close remarks dialog"
                        >
                            <CloseIcon id="clearPopup" />
                        </button>
                    </div>
                </DialogTitle>
                <DialogContent className="inst-remarks-dialog__content">
                    <TextField
                        autoFocus
                        id="iv_remarks"
                        placeholder="Enter Remarks"
                        type="text"
                        fullWidth
                        variant="outlined"
                        onChange={remarksFormik.handleChange}
                        onBlur={remarksFormik.handleBlur}
                        name="iv_remarks"
                        value={remarksFormik.values.iv_remarks}
                        multiline
                        minRows={5}
                        maxRows={8}
                        className="inst-remarks-dialog__textarea"
                        error={Boolean(remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks)}
                    />
                    {remarksFormik.touched.iv_remarks && remarksFormik.errors.iv_remarks ? (
                        <p className="inst-remarks-dialog__error">{remarksFormik.errors.iv_remarks}</p>
                    ) : null}
                    {error ? (
                        <Error
                            error={error}
                            onClose={() => errorCloses()}
                            backgroundColor="#FFC0CB"
                            textColor="#bb0303"
                            iconColor="#bb0303"
                        />
                    ) : null}
                </DialogContent>
                <DialogActions className="inst-remarks-dialog__actions">
                    <Button
                        type="button"
                        onClick={remarksFormik.handleSubmit}
                        className="inst-remarks-dialog__btn inst-remarks-dialog__btn--confirm"
                    >
                        Confirm
                    </Button>
                    <Button
                        type="button"
                        onClick={handleCloseRemarks}
                        className="inst-remarks-dialog__btn inst-remarks-dialog__btn--cancel"
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={Boolean(activeInstResultDialog)}
                onClose={handleClosePopup}
                className={`dde-result-dialog${resultPopup === 'reject' || apiPopup.type === 'error' ? ' dde-result-dialog--reject' : ''}`}
                fullWidth
                maxWidth="sm"
                PaperProps={{ className: 'dde-result-dialog__paper' }}
            >
                {activeInstResultDialog ? (
                    <>
                        <DialogTitle className="dde-result-dialog__title">
                            <Box className="dde-result-dialog__icon-wrap">
                                <activeInstResultDialog.Icon className={activeInstResultDialog.iconClassName} />
                            </Box>
                            <Typography variant="h6" className="dde-result-dialog__heading">
                                {activeInstResultDialog.title}
                            </Typography>
                        </DialogTitle>
                        <DialogContent className="dde-result-dialog__content">
                            <DialogContentText>
                                <p className="dde-result-dialog__message">{activeResultMessage}</p>
                                {activeResultInnerMessage && activeResultInnerMessage !== activeResultMessage ? (
                                    <p className="dde-result-dialog__message">{activeResultInnerMessage}</p>
                                ) : null}
                                {activeInstResultDialog.showBill ? (
                                    <Box className="dde-result-dialog__actions">
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            className="dde-result-dialog__bill-btn"
                                            onClick={() => downloadBill(dialogRowData.refNo)}
                                        >
                                            <DescriptionIcon className="dde-result-dialog__bill-icon" />
                                            Bill
                                        </Button>
                                    </Box>
                                ) : null}
                            </DialogContentText>
                        </DialogContent>
                    </>
                ) : null}
            </Dialog>


            {/* Backdrop */}
            < Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
                open={viewBackdrop}
            >
                <AppLoader />
            </Backdrop >

        </>
    )
});

export default InstallmentsTable;